module.exports = __webpack_public_path__ + "static/media/notification.108025b1.wav";